export const DASHBOARD = 'dashboard'
export const STORIES = DASHBOARD + '/stories'
export const ACTIVITIES = DASHBOARD + '/activities'
export const NOTIFICATIONS = DASHBOARD + '/notifications'
export const LEADERBOARD = DASHBOARD + '/leaderboard'
export const PROFILE = DASHBOARD + '/profile'
export const MY_BADGES = DASHBOARD + '/my-badges'
export const FEED = DASHBOARD + '/feed'
export const REDIRECT_PAGE = 'redirect-page'
export const HOME = '/'
export const SUPPORT = DASHBOARD + '/support'
export const DIFFERENT_ACTIVITY = DASHBOARD + '/different-activity'
export const SELECT_PRO_TRACK = 'select-protrack'
export const START = 'start'
export const ON_BOARDING_LANDING = 'on-boarding-landing'
export const LOGIN = 'login'
export const PREVIOUS_PROTRACKS = DASHBOARD + '/previous-protracks'
export const TOUR = 'tour'
export const SUPPORT_PAGE = 'support'
